import styled from 'styled-components';

export const Wrapper = styled.div<{
  iconColor: string;
  hoverBackground: string;
}>`
  width: 100%;
  background: #ffffff;

  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 12px;

  transition: all 0.4s;

  cursor: pointer;

  svg {
    path {
      fill: ${props => props.iconColor};
    }
  }
`;

export const IconWrapper = styled.div<{ iconColor: string }>`
  width: 36px;
  height: 36px;
  background: ${props => props.iconColor};

  border-radius: 12px;

  display: flex;
  justify-content: center;
  align-items: center;

  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;

    path,
    rect {
      fill: #ffffff;
    }
  }
`;
